<template>
  <div id="app">
    <router-view :siteList="siteList" />
    <!-- 侧边栏 -->
    <div id="sidebar">
      <div @mouseover="showChengxu=true" @mouseleave="showChengxu=false" class="hover-revert re1">
        <div class="si"><i class="si1"></i></div>
        <div class="text">企业微信</div>
        <div v-show="showChengxu" class="tooltip">
          <div class="tooltip_content">
            <img :src="siteList.kefu">
            <div>企业微信</div>
            <div class="tooltip_arrow"></div>
          </div>
        </div>
      </div>
      <div @mouseover="showPublic=true" @mouseleave="showPublic=false" class="hover-revert re2">
        <div class="si"><i class="si2"></i></div>
        <div class="text">公众号</div>
        <div v-show="showPublic" class="tooltip">
          <div class="tooltip_content">
            <img :src="siteList.wechat_public">
            <div>友道科技公众号</div>
            <div class="tooltip_arrow"></div>
          </div>
        </div>
      </div>
      <div class="hover-revert re3">
        <a href="#">
          <div class="si"><i class="si3"></i></div>
          <div class="text">会员</div>
        </a>
      </div>
      <div @mouseover="showKefu=true" @mouseleave="showKefu=false" class="hover-revert re4">
        <div class="si"><i class="si4"></i></div>
        <div class="text">微信</div>
        <div v-show="showKefu" class="tooltip">
          <div class="tooltip_content">
            <img :src="siteList.kefu">
            <div>微信扫码添加专属客服</div>
            <div class="tooltip_arrow"></div>
          </div>
        </div>
      </div>
      <div class="hover-revert sfeedback re5">
        <div class="si"><i class="si5"></i></div>
        <div class="text">反馈</div>
      </div>
      <div @mouseover="xnKefu=true" @mouseleave="xnKefu=false" class="hover-revert re6">
        <div class="si"><i class="si6"></i></div>
        <div class="text">立即咨询</div>
        <div v-show="xnKefu" class="tooltip">
          <div class="tooltip_content">
            <img :src="siteList.kefu">
            <div>友道科技客服</div>
            <div class="tooltip_arrow"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import '@/libs/baiduScripts.js';
  export default {
    data() {
      return {
        showChengxu: false,
        showPublic: false,
        showKefu: false,
        xnKefu: false,
        siteList: []
      }
    },
    created() {
      this.getSite()
    },
    methods: {
      async getSite() {
        let res = await this.$request.post('seo/getSite')
        if (res.data.code === 0) {
          this.siteList = res.data.data[0]
        }
      }
    },
  }
</script>

<style lang="scss">

</style>